import React, { useEffect } from 'react';
import { IoNotificationsOutline } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import useNotificationStore from '../../store/notificationStore';

const NotificationIcon = () => {
  const navigate = useNavigate();
  const { hasUnread, isLoading, checkUnreadNotifications } = useNotificationStore();

  useEffect(() => {
    // 컴포넌트 마운트 시 체크
    checkUnreadNotifications();
  }, []);

  return (
    <div className="relative">
      <IoNotificationsOutline 
        size={24} 
        className={`text-gray-600 ${isLoading ? 'opacity-50' : ''}`}
        onClick={() => navigate('/app/mypage/notification')}
      />
      {hasUnread && !isLoading && (
        <div className="absolute -top-1 -right-1 w-2 h-2 bg-amber-500 rounded-full" />
      )}
    </div>
  );
};

export default NotificationIcon; 